import { useMemo } from "react";
import { useList } from "@refinedev/core";
import { IwiData } from "@/interfaces/iwi";

export const useIwiSelection = (iwiValue: number[] | undefined) => {
  const { data: iwiData } = useList({
    resource: "iwi",
    config: {
      pagination: { current: 1, pageSize: 200 },
    },
  });

  const iwiList = useMemo(
    () => (iwiData?.data as IwiData[]) || [],
    [iwiData?.data]
  );

  const selectedIwi = useMemo(() => {
    if (!iwiValue) return [];
    return iwiValue
      .map((iwiId: number) => iwiList.find((iwi) => iwi.id === iwiId))
      .filter((iwi): iwi is IwiData => iwi !== undefined);
  }, [iwiValue, iwiList]);

  return { iwiList, selectedIwi };
};
